import React, { FunctionComponent } from 'react';
import { Form, Field } from 'react-final-form';
import { Flex, Button, RadioField } from 'mdlkit';
import { PatientAffiliation } from '../../../interfaces/register';
import { REGISTRATION } from '../../../constants/events';
import { event } from '../../../lib/analytics';

interface Props {
  affiliations: PatientAffiliation[];
  onSubmit({ affiliationId: string }): void;
}

const AffiliationForm: FunctionComponent<Props> = ({
  affiliations,
  onSubmit,
}: Props) => (
  <Form
    initialValues={{ affiliationId: affiliations[0].id.toString() }}
    onSubmit={onSubmit}
    render={({ handleSubmit }) => (
      <Flex as="form" column align="center" pt="md" onSubmit={handleSubmit}>
        <div role="radiogroup" aria-labelledby="affiliation">
          {affiliations.map(affiliation => (
            <Field
              key={affiliation.id}
              id={`affiliationId_${affiliation.id}`}
              type="radio"
              name="affiliationId"
              label={affiliation.description}
              component={RadioField}
              value={affiliation.id.toString()}
            />
          ))}
        </div>
        <Button
          mt="md"
          id="affiliationFormBtn"
          type="submit"
          size="large"
          onClick={() => {
            event({
              action: 'choose_affiliation_account_recovery',
              category: REGISTRATION,
            });
          }}
        >
          Continue
        </Button>
      </Flex>
    )}
  />
);

export default AffiliationForm;
